const challenges = {
  DEVICE_SRP_AUTH: 'DEVICE_SRP_AUTH',
  DEVICE_PASSWORD_VERIFIER: 'DEVICE_PASSWORD_VERIFIER',
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED'
}

export default challenges;